import { useEffect } from "react";
import { LuX } from "react-icons/lu";
import * as styled from "./Shop.styled";

// Модальне вікно магазину: закривається хрестиком, кліком повз вікно або Esc
function ShopModal({ onClose, children }) {
  useEffect(() => {
    const handleKey = (event) => event.key === "Escape" && onClose();
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onClose]);

  return (
    <styled.Overlay onClick={onClose}>
      <styled.Modal role="dialog" aria-modal="true" onClick={(event) => event.stopPropagation()}>
        <styled.CloseButton onClick={onClose} aria-label="Закрити">
          <LuX size={20} />
        </styled.CloseButton>
        {children}
      </styled.Modal>
    </styled.Overlay>
  );
}

export default ShopModal;
